import { githubEvents } from "subscriptions/githubEvents";
import type { GitHubEvents } from "subscriptions/githubEvents";
import type { UseSubscriptionResponse } from "urql";
import { useSubscription } from "urql";

/**
 * SubscriptionVariables are the arguments
 * passed to he graphql subscription
 */
interface SubscriptionVariables {
  owner: string;
  repo: string;
}

export const useGithubEventsSubscription = (
  variables: SubscriptionVariables,
): UseSubscriptionResponse<GitHubEvents, SubscriptionVariables> =>
  useSubscription({
    query: githubEvents,
    variables,
  });
